import React from 'react'
// @ts-ignore
import styles from './AnimatedCard.module.scss'

class AnimatedCard extends React.Component<AnimatedCardProps, AnimatedCardState> {

  private card: any = null
  private figureIcon: any = null
  private title: any = null
  private body: any = null
  private button: any = null

  constructor(props: AnimatedCardProps) {
    super(props)
    this.state = {
      mainClass: ''
    }
  }

  componentDidMount() {
    this.card = document.querySelector(`.${styles.cardDefault}`)
    this.figureIcon = document.querySelector(`.${styles.cardDefault} .figure img`)
    this.title = document.querySelector(`.${styles.cardDefault} .content .title`)
    this.body = document.querySelector(`.${styles.cardDefault} .content .body`)
    this.button = document.querySelector(`.${styles.cardDefault} .footer .footer_btn`)

    React.Children.forEach(this.props.children, element => {
      if (!React.isValidElement(element)) return

      this.setState({ mainClass: element.props.className })

    })

  }


  _onMouseMove = (e: any) => {
    let card = this.card;
    const { config } = this.props;

    let xAxis = (window.innerWidth / 2 - e.pageX) / (config?.rotation || 15);
    let yAxis = (window.innerHeight / 2 - e.pageY) / (config?.rotation || 15);

    card.style.transition = 'all 0.1s ease';
    card.style.transform = `rotateY(${xAxis}deg) rotateX(${yAxis}deg)`;
  }

  _onMouseLeave = () => {
    let card = this.card
    const { config } = this.props

    card.style.transition = `all ${config && config.transition?.duration || 0.5}s ease`;
    card.style.transform = `rotateY(0deg) rotateX(0deg)`;

    if (this.title) this.title.style.transform = 'translateZ(0px)';
    if (this.body) this.body.style.transform = 'translateZ(0px)';
    if (this.button) this.button.style.transform = 'translateZ(0px)';
    if (this.figureIcon) this.figureIcon.style.transform = 'translateZ(0) rotateZ(0deg)';
  }

  _onMouseEnter = () => {
    let card = this.card
    const { config } = this.props

    card.style.transition = `all ${config && config.transition?.duration || 0.5}s ease`;

    if (this.title) this.title.style.transition = `all ${config && config.transition?.duration || 0.5}s ease`;
    if (this.body) this.body.style.transition = `all ${config && config.transition?.duration || 0.5}s ease`;
    if (this.button) this.button.style.transition = `all ${config && config.transition?.duration || 0.5}s ease`;
    if (this.figureIcon) this.figureIcon.style.transition = `all ${config && config.transition?.duration || 0.5}s ease`;

    if (this.title) this.title.style.transform = `translateZ(${config && config.transform?.titleTranslateZ || 140}px)`;
    if (this.body) this.body.style.transform = `translateZ(${config && config.transform?.bodyTextTranslateZ || 125}px)`;
    if (this.button) this.button.style.transform = `translateZ(${config && config.transform?.buttonTranslateZ || 100}px)`;
    if (this.figureIcon) this.figureIcon.style.transform = `translateZ(${config && config.transform?.figureIcon?.translateZ || 160}px) rotateZ(${config && config.transform?.figureIcon?.rotation || 45}deg)`;
  }

  render() {
    const { children, className, style } = this.props
    const { mainClass } = this.state

    return (
      <div
        className={[styles.container, className].join(' ')}
        onMouseMove={this._onMouseMove}
        onMouseLeave={this._onMouseLeave}
        onMouseEnter={this._onMouseEnter}
        {...{ style }}
      >

        {React.isValidElement(children) && React.cloneElement(children as React.ReactElement, { className: mainClass + ' ' + styles.cardDefault })}
      </div>
    )
  }
}

interface transitionProps {
  duration: number;
  timingMode?: 'ease' | 'ease-out' | 'ease-in' | 'ease-in-out';
}

interface transformProps {
  figureIcon?: {
    rotation?: number;
    translateZ?: number
  },
  titleTranslateZ?: number;
  buttonTranslateZ?: number;
  bodyTextTranslateZ?: number;
}

interface ObjectProps {
  transition?: transitionProps;
  rotation?: number;
  transform?: transformProps;
}

interface AnimatedCardProps {
  config?: ObjectProps;
  className?: string;

  [key: string]: any;
}

interface AnimatedCardState {
  mainClass: string;
}

export default AnimatedCard
